
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PHeading',
  props: {
    dsColor: {
      type: String,
      default: null,
    },
    dsSize: {
      type: String,
      default: 'xxxl',
    },
    tag: {
      type: String,
      default: 'h1',
    },
  },
})
